export default {
  'ASKING' (state) {
    return state.asking
  },
  'ASKINGS' (state) {
    return state.askings
  }
}
